/* ==========================================================================
 * aef-hero-video.js — nạp video hero MUỘN, có chủ đích.
 *
 * Bài toán: video hero là file nặng nhất trang (bản 720p ~11MB) và nó nằm ngay
 * màn hình đầu. Nhúng kiểu thông thường (<video autoplay src=...>) là nó giành
 * băng thông đúng lúc trình duyệt đang cần tải CSS + ảnh sản phẩm, kéo tụt LCP —
 * mà theo số của chính Shopify 2026, LCP chậm thêm 100ms = conversion giảm 3.5%.
 *
 * Cách làm ở đây:
 *   1. Trong HTML, <source> để trống src (chỉ có data-src) → trình duyệt không
 *      tải gì cả. Ảnh bìa (poster) hiện ngay, và chính nó là phần tử tính LCP.
 *   2. Chỉ khi hero lọt vào tầm nhìn VÀ trình duyệt rảnh, mới gắn src + load().
 *   3. Chọn độ phân giải theo bề rộng màn: điện thoại lấy bản 480p (~3.7MB),
 *      desktop lấy 720p. Không bao giờ đụng bản 1080p 7.2Mbps.
 *
 * prefers-reduced-motion: KHÔNG tự chạy. Người bật "giảm chuyển động" thường là
 * người bị chóng mặt vì hình động — với họ, video 20 giây lặp vô tận ngay màn
 * đầu là thứ tệ nhất. Họ vẫn xem được: hiện nút play, bấm là chạy.
 * ========================================================================== */
(function () {
  'use strict';

  // Section Rendering API tiêm lại HTML kèm thẻ <script src> mỗi lần section
  // được vẽ lại → không có chốt này thì có 2 bộ observer + 2 listener nút tiếng,
  // bấm một cái tắt/bật hai lần thành ra không đổi gì. Cùng khuôn với
  // aef-marketdeals.js và cart-drawer.
  if (window.__aefHeroVideo) return;
  window.__aefHeroVideo = true;

  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* Khách bật "tiết kiệm dữ liệu" (Data Saver trên Android/Chrome, Low Data Mode
   * trên iOS) là khách đã NÓI RA rằng họ đang trả tiền theo từng megabyte, hoặc
   * sóng yếu. Video hero là file nặng nhất trang: bản 480p của video 1 ~1,9 MB,
   * video 2 ~4,7 MB. Tự tải chúng về cho người vừa xin đừng tải là phớt lờ đúng
   * cái họ bấm.
   *
   * Theme này ĐÃ tôn trọng cờ đó ở chỗ khác: assets/tiny-img-link-preloader.js
   * tắt hẳn prefetch khi `saveData` bật. Hero là chỗ tốn băng thông nhất mà lại
   * là chỗ duy nhất bỏ qua — nên đây là vá cho khớp phần còn lại của theme,
   * không phải quy ước mới.
   *
   * Cách xử: y như prefers-reduced-motion — KHÔNG tự tải, hiện ảnh bìa + nút ▶.
   * Khác một điểm quan trọng: ở nhánh reduced-motion nguồn ĐÃ được gắn sẵn nên
   * nút ▶ chỉ cần play(); ở đây nguồn CHƯA gắn, nên nút phải tự đi gắn trước.
   * Xem tham số `doKhachBam` của attachSources.
   *
   * `navigator.connection` không có trên Safari/Firefox ⇒ mặc định false, tức là
   * hành vi cũ. Không ai mất gì.
   * Người gác: scripts/test-hero-ton-trong-tiet-kiem-du-lieu.js */
  var TIET_KIEM = false;
  try { TIET_KIEM = !!(navigator.connection && navigator.connection.saveData); } catch (e) {}

  /* ĐÃ CHẠM VÀO TRANG CHƯA — cổng của video 2, và nó là chuyện ĐO ĐƯỢC chứ
   * không phải chuyện thẩm mỹ.
   *
   * Đo trên LIVE 7/9/2026, trang chủ 🖥 1440, khách không bấm gì:
   *     1612ms  size=656264  img.aefhv__poster    ← LCP đúng như thiết kế
   *    14320ms  size=659771  video.aefhv__vid2    ← cướp mất
   * Chênh nhau 3.507 điểm ảnh, tức 0,53%. Poster bị chặn trần ở đúng độ phân
   * giải của nó (1080×608 = 656.640), còn video 2 lấy bản 1280×720 nên vượt
   * trần và lấp đầy trọn khung 1440×458. Chrome thấy một mảng "lớn hơn" sơn ra
   * ở giây 14 và dời LCP sang đó: 1,6s → 14,3s. Không log, không lỗi, không ai
   * thấy — chỉ có Core Web Vitals tụt.
   *
   * VÌ SAO CHỌN CỔNG "ĐÃ CHẠM" chứ không phải mấy cách kia:
   *   ✗ Hạ video 2 xuống bản 480p cho desktop — hết cướp LCP thật, nhưng đem
   *     video quảng cáo Boss vừa quay ra chiếu mờ hơn video còn lại. Đổi một
   *     con số lấy chất lượng thứ khách NHÌN THẤY.
   *   ✗ Thu nhỏ khung video 2 vài pixel cho nó đừng "lớn hơn" — chạy được,
   *     nhưng là mẹo đối phó với thước đo. Đổi poster một cái là quan hệ lật
   *     ngược và không ai biết vì sao.
   *   ✓ Chrome CHỐT LCP ở cú nhập liệu đầu tiên của khách. Nên chỉ cần video 2
   *     xuất hiện SAU cú chạm đầu tiên là nó vĩnh viễn không thể là ứng viên
   *     LCP, bất kể độ phân giải sau này thế nào. Bền theo nguyên lý, không bền
   *     theo con số.
   *
   * 🔴 8/9/2026 — CHỖ NÀY TỪNG VIẾT "(bấm/gõ — cuộn KHÔNG tính)". SAI, VÀ CÂU SAI
   * ẤY CHÍNH LÀ CON BUG.
   * Tin rằng cuộn không chốt LCP thì tự khắc không dám nghe cuộn, nên danh sách
   * dưới chỉ có bấm/gõ/chạm. Hệ quả: khách DESKTOP chỉ lăn chuột — không bấm gì —
   * thì cổng không bao giờ mở, video 2 không tải một byte, video 1 cứ lặp. Không
   * lỗi, không log, màn hình trông hoàn toàn bình thường.
   *
   * ĐO 8/9 (playwright chromium): trang có ứng viên LCP nhỏ, tới giây 3 tiêm một
   * khối chữ TO HƠN, rồi hỏi PerformanceObserver xem khối to có được báo không.
   *     A  không làm gì            → ĐƯỢC báo (size 433.680)  ⇒ LCP còn mở
   *                                  (đối chứng: chứng minh CÁI THƯỚC còn sống)
   *     B  mouse.wheel(0, 60)      → KHÔNG được báo            ⇒ CUỘN CHỐT LCP
   *     C  window.scrollTo(0, 60)  → ĐƯỢC báo (size 398.320)  ⇒ cuộn LẬP TRÌNH không chốt
   *     D  mouse.click             → KHÔNG được báo            (đối chứng đã biết)
   * B và C cuộn ĐÚNG 60px như nhau, chỉ khác nguồn gốc sự kiện — nên B không phải
   * ảo giác "khối bị cuộn khỏi tầm nhìn". Và lăn chuột vẫn chốt LCP kể cả khi
   * trang KHÔNG nhích một pixel: lăn LÊN ở đỉnh trang (scrollY=0) chốt; trang
   * ngắn 400px không có gì để cuộn cũng chốt.
   * web.dev/articles/lcp nói đúng thế: "…as soon as the user interacts with the
   * page (via a tap, scroll, or keypress)".
   *
   * 🔴 VÌ THẾ: THÊM 'wheel', VÀ TUYỆT ĐỐI KHÔNG THÊM 'scroll'.
   * Ca C là lý do. Cuộn do LẬP TRÌNH (scrollTo / scrollIntoView) KHÔNG chốt LCP
   * nhưng vẫn bắn sự kiện 'scroll', mà listener dưới gắn capture:true ở tầng
   * document nên nó bắt được cả cuộn của khung con. Kho có sẵn mấy chỗ như thế:
   * aef-swipe.js:68 · aef-app.js:3345 · aef-head.js:754. Nghe 'scroll' là mở cổng
   * trong lúc LCP CÒN MỞ ⇒ dựng lại đúng con bug 1,6s → 14,3s ở trên.
   *
   * ĐƯỢC THÊM: khách vào rồi thoát mà không chạm gì thì KHÔNG tải video 2 —
   * 14 MB (bản 720p × 25 giây) không bị tiêu cho người sắp rời đi.
   *
   * MẤT GÌ, NÓI THẲNG: khách ngồi im hoàn toàn — không bấm, không gõ, không lăn —
   * thì không thấy video quảng cáo. Boss muốn nó chạy vô điều kiện thì gỡ đúng
   * cổng này, và chấp nhận LCP trang chủ 14,3 giây.
   *
   * THEME EDITOR ĐƯỢC MIỄN. Trình sửa giao diện chạy cửa hàng trong một IFRAME;
   * cú bấm của Boss vào bảng cài đặt rơi vào TÀI LIỆU CHA nên listener dưới không
   * nghe thấy. Boss phải bấm đúng vào trong khung xem trước mới mở được cổng —
   * và đổi ô nào khiến iframe nạp lại thì cờ về false. Hành vi lúc thấy lúc
   * không, đúng thứ làm người ta kết luận "tính năng hỏng". LCP trong editor
   * không phục vụ ai, nên bỏ qua cổng ở đó là đổi lấy đúng thứ đáng đổi. Đây là
   * nếp sẵn có của kho: lazy-sections.js:123, product-model.js:57,
   * wbquickview.liquid:235 đều bỏ qua cổng lười khi designMode.
   *
   * `capture:true` để bắt được cú chạm kể cả khi thứ khác gọi stopPropagation.
   * `passive:true` để không cản cuộn. `once` từng cái để tự tháo sau lần đầu.
   * Người gác: scripts/test-hero-noi-tiep-hai-video.js, mệnh đề H và H2. */
  var daTuongTac = !!(window.Shopify && window.Shopify.designMode);
  function danhDauTuongTac() { daTuongTac = true; }
  ['pointerdown', 'mousedown', 'keydown', 'click', 'touchstart', 'wheel'].forEach(function (t) {
    try {
      document.addEventListener(t, danhDauTuongTac, { once: true, passive: true, capture: true });
    } catch (e) {
      document.addEventListener(t, danhDauTuongTac, true);
    }
  });

  // Hero đang sống hiện tại. Cần biến ở tầng module vì theme editor vẽ lại section
  // (Boss kéo thanh trượt chiều cao là vẽ lại) — node cũ bị vứt, node mới thay chỗ,
  // nên listener gắn ở tầng document phải luôn trỏ tới node MỚI chứ không giữ node cũ.
  var curRoot = null, curVideo = null, visBound = false;

  // Mốc "đã hết việc gấp" = sự kiện load, KHÔNG phải requestIdleCallback.
  //
  // Lý do (đã đo, không đoán): trong TAB NỀN, Chrome hoãn hẳn requestIdleCallback
  // — kể cả khi có `timeout` — và gần như dừng IntersectionObserver, vì IO chỉ
  // chạy theo nhịp vẽ lại mà tab nền thì không vẽ. Đo trực tiếp: sau 6 giây, rIC
  // và IO đều CHƯA chạy lần nào, trong khi setTimeout(…, 0) chạy ở 0ms.
  // Đây là tình huống thật của khách: bấm link mở ở tab mới rồi vẫn đọc tab cũ
  // vài chục giây. Với bản cũ, video còn chưa BẮT ĐẦU tải khi họ chuyển sang.
  // Sau `load` thì mọi thứ then chốt đã tải xong — vẫn giữ đúng mục tiêu ban đầu
  // (không tranh băng thông lúc trang đang vẽ) mà không phụ thuộc hai API bị bóp.
  function afterLoad(fn) {
    if (document.readyState === 'complete') { setTimeout(fn, 0); return; }
    window.addEventListener('load', function () { setTimeout(fn, 0); }, { once: true });
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight || 0;
    return r.bottom > -200 && r.top < h + 200;
  }

  /* chiNap = CHỈ nạp sẵn, chưa tới lượt chạy. Dùng cho video 2 của danh sách nối
   * tiếp: nạp trước vài giây để lúc chuyển cảnh không khựng, nhưng không được
   * play() (hai video cùng kêu) và không được showPlay() (đẻ nút ▶ thứ hai chồng
   * lên nút thứ nhất). */
  function attachSources(video, chiNap, doKhachBam) {
    if (video.dataset.aefLoaded) return;

    /* Cổng tiết kiệm dữ liệu. Đặt TRƯỚC khi cắm cờ `aefLoaded` là có chủ đích:
     * cờ đó vừa là chốt chống gắn hai lần, vừa là câu trả lời cho "video này đã
     * sẵn sàng chưa" ở bốn chỗ khác (nút loa, cú bấm vào hero, bộ quan sát tầm
     * nhìn, và `sanSang` của danh sách nối tiếp). Cắm cờ rồi mới quay ra là nói
     * dối cả bốn chỗ đó: chúng sẽ tưởng video đã nạp xong trong khi thẻ còn rỗng.
     *
     * `chiNap` = lời gọi nạp trước video 2. Quay ra IM LẶNG, không hiện nút ▶ —
     * nút ▶ thứ hai chồng lên nút của video 1 là hai nút đè nhau ở một góc.
     * Hệ quả dây chuyền đúng như mong muốn: `sanSang(kia)` không bao giờ thành
     * true ⇒ không có cú chuyển cảnh ⇒ video 1 cứ lặp bằng thuộc tính `loop` của
     * chính nó. Tức là khách tiết kiệm dữ liệu tụt về đúng hành vi một-video.
     */
    if (TIET_KIEM && !doKhachBam) {
      if (!chiNap) showPlay(video);
      return;
    }

    video.dataset.aefLoaded = '1';

    var srcs = [].slice.call(video.querySelectorAll('source[data-src]'));
    if (!srcs.length) return;

    /* Chọn độ phân giải theo BỀ RỘNG THẬT của khung, không phải "lấy bản to nhất".
     *
     * Bản đầu lấy srcs[cuối] trên desktop. Khi Boss chọn video trong theme editor,
     * Shopify trả về CẢ bản 1080p — với video dọc là 606×1080 ở 7.2 Mbps, tức ~18MB
     * cho 20 giây, để đổ vào một khung rộng 398px. Đường dự phòng chỉ khai báo 2
     * bản nên lỗi này không lộ ra lúc thử; nó chỉ hiện khi Boss thao tác trong editor.
     *
     * Luật: điện thoại luôn lấy bản nhẹ nhất (tiết kiệm 4G, khung nhỏ nên không
     * thấy khác). Desktop lấy bản LỚN NHẤT mà không vượt quá 1.5× bề rộng khung —
     * đủ nét cho màn Retina, mà vẫn loại thẳng bản 1080p ra khỏi khối 398px.
     * Ở chế độ nền tràn ngang, khung rộng ~1440px nên ngưỡng 1.5× tự nới ra và
     * bản lớn nhất được chọn — đúng như mong muốn cho video quay ngang sau này. */
    /* MẠNG YẾU ⇒ lấy bản nhẹ nhất, bất kể màn hình to bằng nào.
     *
     * Luật cũ chỉ hỏi BỀ RỘNG. Một cái laptop nối 4G yếu ở quán cà phê vẫn bị
     * xếp vào nhóm "màn to" và nhận bản nặng nhất — đo trên LIVE: trang chủ 🖥
     * tải 3,36 MB video, chiếm gần nửa tổng 7,46 MB của cả trang.
     *
     * Đây KHÔNG PHẢI chuyện tiết kiệm dữ liệu (`saveData`, cổng riêng phía trên):
     * cờ kia là khách TỰ BẤM để xin đừng tải; cờ này là mạng đang thực sự chậm dù
     * khách không xin gì. Hai chuyện khác nhau nên xử ở hai chỗ khác nhau.
     *
     * `effectiveType` là ước lượng của trình duyệt dựa trên độ trễ và thông lượng
     * đo được, không phải loại sóng khai báo — nên "4g" vẫn có thể tụt xuống "3g"
     * khi mạng thật sự tệ, đúng thứ mình muốn bắt. Safari/Firefox không có API này
     * ⇒ false ⇒ giữ nguyên hành vi cũ, không ai mất gì.
     *
     * 🔴 vòng 48, 14/9/2026 — CHỖ NÀY TỪNG VIẾT "KHÔNG dùng cho video 2: nó vốn đã
     * bị cổng 'đã chạm' chặn từ trước". SAI, và sai theo hướng làm người sau đi vá
     * thừa. `mangYeu` nằm TRONG attachSources, mà video 2 cũng đi qua đúng hàm này
     * (dòng `attachSources(kia, true)` của nhịp chuyển cảnh) ⇒ cổng mạng yếu áp CẢ
     * HAI thẻ. Dựng lại bằng jsdom 14/9/2026, khung 1024: effectiveType='3g' cho
     * video 2 lấy bản 852px (5,12 MB) thay vì 1280px (14,39 MB). Cổng "đã chạm"
     * lọc NGƯỜI (ai được tải), cổng này lọc BẢN (tải bản nào) — hai việc khác nhau. */
    var mangYeu = false;
    try {
      var mang = navigator.connection;
      if (mang && /^(slow-2g|2g|3g)$/.test(mang.effectiveType || '')) mangYeu = true;
    } catch (e) {}

    /* MÁY CẢM ỨNG MÀN VỪA ⇒ cũng lấy bản nhẹ nhất. vòng 48, 14/9/2026.
     *
     * Ngưỡng 640 là proxy cho "điện thoại", và nó chỉ đúng với điện thoại CẦM DỌC.
     * Xoay ngang một cái là innerWidth nhảy lên 844–932, máy tính bảng thì 768–1024
     * — tất cả rơi vào nhánh "màn to" và ăn bản nặng nhất.
     *
     * ĐO THẬT 14/9/2026 (HEAD, Content-Length trên 4 URL LIVE):
     *   video 1  852px = 2,24 MB · 1080px (file GỐC /c/o/v/, không transcode) = 3,44 MB
     *   video 2  852px = 5,12 MB · 1280px = 14,39 MB
     * Dựng lại bằng jsdom, chạy NGUYÊN file này, boxW = innerWidth (chế độ cover):
     *   iPad NGANG 1024      trước 3,44 + 14,39 = 17,83 MB → sau 2,24 + 5,12 = 7,36 MB
     *   iPhone PM nằm ngang 932  y hệt: 17,83 MB → 7,36 MB
     *   iPad DỌC 768          trước 3,44 + 5,12 = 8,56 MB → sau 7,36 MB
     *   🖥 1440 chuột         17,83 MB → 17,83 MB (KHÔNG đổi một byte)
     *
     * VÌ SAO `pointer: coarse` CHỨ KHÔNG PHẢI devicePixelRatio. Cách "kẹp trần theo
     * DPR" (tran = boxW * Math.min(1.5, dpr)) là NO-OP trên đúng thiết bị cần vá:
     * iPad có DPR 2, iPhone Pro Max DPR 3 ⇒ Math.min(1.5, 2) = 1.5 ⇒ trần y hệt hôm
     * nay. Nó chỉ đổi hành vi cho máy DPR 1. `pointer: coarse` cũng là nếp sẵn có
     * của chính hero: sections/aef-hero-video.liquid đã dùng @media (pointer: coarse)
     * ở hai chỗ. Laptop có màn cảm ứng khai con trỏ CHÍNH là `fine` ⇒ không dính.
     *
     * VÌ SAO CÓ THÊM TRẦN 1100. Máy tính bảng lớn cầm ngang (iPad Pro 12,9" = 1366)
     * là màn to thật và gần như luôn ở wifi — để nguyên nhánh cũ. 1100 nằm giữa
     * 1024 (iPad ngang, cần vá) và 1366 (không cần).
     *
     * ĐÁNH ĐỔI, NÓI THẲNG: mất nét. 1024 CSS × DPR 2 = 2048 điểm ảnh vật lý; bản
     * 1280 phủ 0,63× số đó, bản 852 phủ 0,42×. Không bản nào "đủ retina" cả, nên
     * đây là đổi 0,21× độ phủ lấy 10,47 MB trên sóng di động, không phải bỏ nét
     * thật lấy nét giả. Muốn cả hai thì đường đúng là nhờ Boss upload thêm một
     * rendition ~1,5 Mbps cho video 2 rồi công thức boxW*1.5 tự chọn đúng — chứ
     * không phải nới lại ngưỡng này.
     *
     * KHÔNG đụng gì tới `loop`/`play()`: chỗ này chỉ chọn MỘT <source> khác, nên
     * bảo đảm "hero không bao giờ đứng hình" của trình duyệt còn nguyên.
     * Người gác: scripts/test-may-cam-ung-khong-an-ban-nang.js */
    var camUngManVua = false;
    try {
      camUngManVua = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)
        && window.innerWidth <= 1100;
    } catch (e) {}

    var small = window.innerWidth <= 640 || mangYeu || camUngManVua;
    srcs.sort(function (a, b) { return (+a.dataset.w || 0) - (+b.dataset.w || 0); });

    var pick;
    if (small) {
      pick = srcs[0];
    } else {
      var boxW = Math.round(video.getBoundingClientRect().width) || 400;
      var tran = boxW * 1.5;
      pick = srcs[0];
      for (var i = 0; i < srcs.length; i++) {
        if ((+srcs[i].dataset.w || 0) <= tran) pick = srcs[i];
      }
    }

    // Giữ đúng MỘT <source>: để nhiều thẻ thì trình duyệt tự chọn cái đầu hợp lệ
    // và bỏ qua tính toán bề rộng ở trên.
    srcs.forEach(function (s) { if (s !== pick) s.parentNode.removeChild(s); });
    pick.src = pick.dataset.src;
    pick.removeAttribute('data-src');

    /* CHỈ video 2 mới được nâng preload lên 'auto'. Video 1 giữ nguyên đường cũ
     * (load() với preload="none" y như trước bản vá nối tiếp) — KHÔNG đụng vào hợp
     * đồng băng thông của thứ đang chạy cho mọi khách trên LIVE, nhất là khi tính
     * năng video 2 còn chưa được bật. Bản trước nâng cho cả hai và đó là một thay
     * đổi hành vi lén lút với 100% khách để phục vụ một tính năng 0% khách đang dùng.
     *
     * Video 2 thì BẮT BUỘC phải có: nó cần đạt readyState >= 3 TRƯỚC khi tới lượt,
     * mà chuyện đó chỉ xảy ra nếu trình duyệt được phép đệm trước. Và nó chỉ được
     * gọi tới khi video 1 ĐANG chạy thật trong tầm mắt — tức khách đang xem — nên
     * đệm trước ở đây là đúng người đúng lúc. */
    if (chiNap) video.preload = 'auto';
    video.load();

    if (chiNap) return;

    /* `doKhachBam` = khách vừa bấm nút ▶. Đó là cử chỉ rõ ràng nhất có thể có, nên
     * nó thắng cả hai cổng. Không có vế `&& !doKhachBam` này thì khách vừa bật
     * tiết kiệm dữ liệu vừa bật giảm chuyển động bấm nút ▶ sẽ rơi vào ngõ cụt:
     * nguồn được gắn, rồi showPlay() quay ra ngay vì nút vẫn còn trong DOM, rồi
     * nút bị gỡ — video nạp xong mà đứng im và không còn đường nào bấm lại. */
    if (REDUCED && !doKhachBam) { showPlay(video); return; }

    // KHÔNG gọi play() ngay sau load(). load() khởi động lại toàn bộ media, và
    // play() chen vào giữa sẽ bị huỷ với AbortError "request was interrupted by a
    // call to load()" — video đứng im ở ảnh bìa dù file đã tải xong, đúng lỗi
    // quan sát được trên preview. Chờ tới khi phát được rồi mới gọi.
    var start = function () {
      var p = video.play();
      // Vẫn có thể bị từ chối (chế độ tiết kiệm pin, trình duyệt chặn autoplay).
      // Khi đó hiện nút play — khách thấy ảnh bìa + nút, không phải khung đen.
      if (p && typeof p.catch === 'function') p.catch(function () { showPlay(video); });
    };
    if (video.readyState >= 3) start();
    else video.addEventListener('canplay', start, { once: true });
  }

  // Nút play cho trường hợp không tự chạy được (reduced-motion / trình duyệt chặn)
  function showPlay(video) {
    /* 6/9/2026, vòng 43 — CHỖ ĐỨNG của nút, không phải chuyện thẩm mỹ.
     * Ở chế độ cover, `.aefhv--cover .aefhv__media{position:absolute; z-index:0}`
     * mở một NGỮ CẢNH XẾP LỚP riêng, nhốt cả cụm `.aefhv__frame` xuống mức 0. Nút
     * nằm trong đó thì z-index:4 chỉ có giá trị BÊN TRONG cụm, còn `.aefhv__copy`
     * (anh em cùng cấp, z-index:2) vẫn vẽ đè và NUỐT cú chạm.
     * Đo bằng elementFromPoint trên chromium chạy file:// (không chạm mạng): bấm
     * đúng tâm nút rơi vào `a.aefhv__btn` ở 390 và 768, vào `.aefhv__copy` ở 1280.
     * Nghĩa là khách bị chặn autoplay bấm "xem video" thì bị ĐẨY SANG trang danh
     * mục, hoặc không có gì xảy ra — mà nút này là đường DUY NHẤT của họ.
     * Đưa nút RA cấp `.aefhv__wrap` là thoát bẫy: đúng nửa còn lại của bản vá nút
     * loa hôm 5/9, xem chú thích dài trong sections/aef-hero-video.liquid.
     * Rẽ nhánh đọc từ CHÍNH lớp `aefhv--cover` sinh ra cái bẫy nên JS và Liquid
     * không có đường nào lệch nhau. Chế độ panel giữ nguyên `.aefhv__frame`: ở đó
     * `.aefhv__wrap` là lưới 2 cột và KHÔNG có position:relative, thả nút vào là
     * nó neo theo cả trang rồi rơi xuống góc dưới màn hình.
     * Người gác: scripts/test-nut-play-du-phong-bam-trung.js */
    var frame = (video.closest('.aefhv--cover') && video.closest('.aefhv__wrap'))
      || video.closest('.aefhv__frame');
    if (!frame || frame.querySelector('[data-aefhv-play]')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'aefhv__sound aefhv__play';
    b.setAttribute('data-aefhv-play', '');
    /* Chữ cho trình đọc màn hình đi ĐÚNG một đường với nút loa: khoá `md.*` cộng
     * bản tiếng Anh làm dự phòng. aefMdI18nText trả null khi từ điển chưa có khoá,
     * và apply() bỏ qua khoá thiếu — nên gắn khoá TRƯỚC là an toàn, không có
     * khoảnh khắc nào nút mất aria-label.
     * ⚠️ CÒN NỢ, KHÔNG GIẤU: khoá `md.hv_play` chưa có trong assets/aef-md-i18n.js
     * (file ngoài phạm vi lượt sửa này). Chừng nào chưa thêm hai dòng
     *     'md.hv_play':'Play video',   (khối en)
     *     'md.hv_play':'Xem video',    (khối vi)
     * thì khách bật tiếng Việt vẫn nghe trình đọc màn hình đọc tiếng Anh — đúng
     * bằng hiện trạng, không tệ hơn. */
    var khoaPlay = 'md.hv_play';
    var chuPlay = (typeof window.aefMdI18nText === 'function') && window.aefMdI18nText(khoaPlay);
    b.setAttribute('aria-label', chuPlay || 'Play video');
    b.setAttribute('data-mdi18n-aria-label', khoaPlay);
    /* CHỖ ĐỨNG của nút nằm TRỌN trong CSS của sections/aef-hero-video.liquid
     * (`.aefhv__sound.aefhv__play`), cạnh ba con số z-index anh em của nó.
     *
     * 7/9/2026, vòng 43 — bản trước để chỗ đứng ở HAI NỬA: hai dòng
     * `b.style.left='12px'; b.style.right='auto'` nằm đúng đây. Chúng đẩy nút
     * xuống góc dưới-TRÁI, tức đúng chỗ nút "Shop mooncakes →" đang đứng. Đo
     * bằng elementFromPoint trên chromium chạy file://: nút ▶ ăn 3/27 điểm bấm
     * của `a.aefhv__btn` ở 390 và 768, 1/27 ở 1280 — khoảng 12% góc dưới-trái
     * của nút CTA chính bấm vào là trúng nút ▶. Đừng dựng lại hai dòng đó;
     * scripts/test-nut-play-du-phong-bam-trung.js đỏ mã AN-CTA nếu có ai thử. */
    b.innerHTML = '<span aria-hidden="true">▶</span>';
    b.addEventListener('click', function () {
      /* Ở nhánh tiết kiệm dữ liệu, thẻ <video> còn RỖNG — play() trên thẻ không có
       * nguồn không làm gì cả và không báo lỗi. Phải gắn nguồn trước rồi để
       * attachSources tự chạy tiếp (nó chờ `canplay` rồi mới play, đúng đường đã
       * chọn để tránh AbortError khi play() chen vào giữa load()). */
      if (!video.dataset.aefLoaded) {
        b.remove();
        attachSources(video, false, true);
        return;
      }
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      b.remove();
    });
    frame.appendChild(b);
  }

  /* ------------------------------------------------------------------ âm thanh
   * Boss chốt 12/8: nút loa ẩn, video chạy câm. Khách bấm vào hero thì được nghe
   * ĐÚNG MỘT vòng rồi tự tắt lại.
   *
   * Vì sao không tự phát tiếng ngay từ đầu: mọi trình duyệt hiện đại chặn autoplay
   * có tiếng. Gọi play() trên video chưa tắt tiếng sẽ bị TỪ CHỐI và video không
   * chạy luôn — mất cả autoplay chứ không phải chỉ mất tiếng. Tiếng bắt buộc phải
   * đến sau một cử chỉ thật của khách.
   *
   * "Một vòng" tính TỪ CHỖ BẤM chứ không phải tới hết file: khách bấm ở giây 18
   * của video 20 giây thì nghe hết vòng rồi chạy tiếp tới giây 18 mới tắt — đúng
   * một lượt xem trọn vẹn, thay vì cụt 2 giây.
   */
  /* dsVideo = mọi video của hero (1 hoặc 2 khi có danh sách nối tiếp).
   * dangChay() = video ĐANG phát. Phải là HÀM chứ không phải giá trị: lúc gắn
   * listener thì video đang chạy là video 1, nhưng cú bấm của khách có thể rơi vào
   * lúc video 2 đang chiếu — hỏi lại tại thời điểm bấm mới đúng.
   *
   * Tiếng luôn ĐỒNG BỘ cả hai thẻ (datCam). Một nguồn duy nhất cho khái niệm
   * "hero có đang kêu không": không thể có cảnh video 2 vào cuộc rồi tự kêu lên
   * trong khi khách đã tắt. [[feedback_one_concept_two_sources]] */
  function bindAudio(root, dsVideo, dangChay) {
    var btn = root.querySelector('[data-aefhv-sound]');
    var spent = false;                 // đã dùng lượt nghe một-lần-duy-nhất
    var vidBam = null, clickAt = 0, prev = 0, wrapped = false;
    var coTieng = false;               // NGUỒN DUY NHẤT: hero có đang cho nghe không

    /* CHỈ thẻ đang chiếu mới được kêu. Bản trước mở tiếng cho CẢ HAI thẻ, mà lúc
     * chuyển cảnh hai thẻ cùng chạy chồng nhau nửa giây (xem DUNG_SAU_MS) — khách
     * đã bật tiếng thì mỗi lần đổi cảnh lại nghe HAI đoạn phim chồng lên nhau. Nhỏ
     * nhưng đúng thứ tai người bắt được ngay. */
    function datCam(m) {
      coTieng = !m;
      for (var i = 0; i < dsVideo.length; i++) {
        dsVideo[i].muted = m || dsVideo[i] !== dangChay();
      }
    }

    // Danh sách nối tiếp gọi lại sau mỗi lần đổi cảnh, để thẻ MỚI thừa kế đúng
    // trạng thái tiếng và thẻ CŨ câm lại.
    function dongBo() { datCam(!coTieng); paint(); }

    function paint() {
      var cam = !coTieng;
      // Class này là thứ cho nút loa hiện ra trong lúc đang có tiếng — khách phải
      // luôn có đường tắt, video kêu mà không có nút tắt là dark pattern.
      root.classList.toggle('aefhv--sound-on', !cam);
      if (!btn) return;
      var ic = btn.querySelector('.aefhv__sound-ic');
      if (ic) ic.textContent = cam ? '🔇' : '🔊';
      var key = cam ? 'md.hv_sound_on' : 'md.hv_sound_off';
      var t = (typeof window.aefMdI18nText === 'function') && window.aefMdI18nText(key);
      btn.setAttribute('aria-pressed', String(!cam));
      btn.setAttribute('aria-label', t || (cam ? 'Turn sound on' : 'Turn sound off'));
      btn.setAttribute('data-mdi18n-aria-label', key);
    }

    function mute() {
      datCam(true);
      for (var i = 0; i < dsVideo.length; i++) dsVideo[i].removeEventListener('timeupdate', onTime);
      paint();
    }

    function onTime(e) {
      var v = e.currentTarget;
      // Đang chiếu video KHÁC video lúc bấm ⇒ đã rời khỏi nó ⇒ vòng đã sang trang.
      // Đây là nhánh của hero hai video: "một vòng" tính trọn cả danh sách rồi mới
      // quay về đúng chỗ khách bấm.
      if (v !== vidBam) { wrapped = true; return; }
      var t = v.currentTime;
      // Thời gian chạy lùi = video vừa quay về đầu. Hero MỘT video thì thẻ mang
      // `loop` nên `ended` không bao giờ bắn — đây là cách duy nhất biết nó đã lặp.
      if (t < prev - 0.25) wrapped = true;
      prev = t;
      if (wrapped && t >= clickAt) mute();
    }

    function unmute(oneShot) {
      var v = dangChay();
      if (coTieng) return;
      if (oneShot) {
        if (spent) return;             // "1 lần thôi" — hết lượt là thôi
        spent = true;
        vidBam = v;
        clickAt = prev = v.currentTime;
        wrapped = false;
        for (var i = 0; i < dsVideo.length; i++) dsVideo[i].addEventListener('timeupdate', onTime);
      }
      datCam(false);
      paint();
      // Bật giảm chuyển động thì video đang đứng im — bấm nghe cũng nên chạy.
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    // Bấm vào hero = bật tiếng. Bỏ qua liên kết và nút: cú bấm vào "Mua ngay" là
    // khách muốn đi mua chứ không phải muốn nghe — cướp nó là làm phiền, và đó
    // đúng là rủi ro đã loại khi chọn phương án này.
    root.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('a,button')) return;
      // Bật "giảm chuyển động" thì KHÔNG cho cú bấm vu vơ vào tiêu đề làm video
      // chạy lên kèm tiếng. Người bật cờ này vừa xin đừng có hình động tự nhảy;
      // họ đã có nút play riêng, và bấm nút đó mới là ý định rõ ràng.
      if (REDUCED) return;
      // Chưa gắn nguồn thì chưa có gì mà nghe. Bật lúc này chỉ làm nút loa hiện ra
      // báo "đang có tiếng" trong khi video đứng im — và tiêu mất lượt nghe duy nhất.
      if (!dangChay().dataset.aefLoaded) return;
      unmute(true);
    });

    // Nút loa (chỉ hiện khi đang có tiếng, hoặc khi Boss bật ô trong theme editor)
    // là công tắc thường: bật/tắt tuỳ ý, không tự tắt sau một vòng.
    if (btn) btn.addEventListener('click', function () {
      if (!coTieng) unmute(false); else mute();
    });

    dongBo();   // đặt trạng thái ban đầu qua ĐÚNG một cửa, không gán tay chỗ khác
    return { dongBo: dongBo };
  }

  function init(scope) {
    var root = (scope && scope.querySelector) ? scope.querySelector('[data-aefhv]') : document.querySelector('[data-aefhv]');
    if (!root) return;
    // Chốt đặt trên CHÍNH NODE, không phải trên window: chốt window chỉ cho chạy
    // một lần duy nhất cả đời trang, mà theme editor thì vẽ lại section liên tục —
    // lần vẽ lại thứ hai sẽ không ai gắn listener và hero chết đứng ở ảnh bìa.
    if (root.dataset.aefhvBound) return;
    root.dataset.aefhvBound = '1';
    var video = root.querySelector('[data-aefhv-vid]');
    if (!video) return;
    var v2 = root.querySelector('[data-aefhv-vid2]');
    var dangChay = video;               // video đang phát
    curRoot = root; curVideo = video;

    function chay(v) {
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
      return p;
    }

    /* 🔴 BẤT BIẾN: CẢ HAI thẻ video luôn mang `loop`. Đây là thứ giữ cho hero không
     * bao giờ đứng hình — một bảo đảm của TRÌNH DUYỆT, không phải một lời gọi có
     * thể bị chối. Danh sách nối tiếp bên dưới chỉ CỘNG THÊM lên trên nó: hỏng
     * hoàn toàn thì khách xem mãi một video, đúng bằng hiện trạng cũ.
     * Vá tại chỗ nếu ai đó lỡ gỡ — người gác thật là
     * scripts/test-hero-noi-tiep-hai-video.js (mệnh đề A), nhưng người gác chỉ soi
     * khi có người chạy nó, còn khách thì vào tiệm mọi lúc. */
    if (!video.loop) video.loop = true;
    if (v2 && !v2.loop) v2.loop = true;

    // Video để trong suốt cho tới khi CHẠY ĐƯỢC thật (xem .aefhv__vid trong CSS),
    // ảnh bìa <img> nằm dưới gánh phần nhìn. Bắt `playing` chứ không phải `canplay`:
    // canplay mới chỉ nói "đủ dữ liệu để chạy", còn `playing` mới chắc chắn khung
    // hình đầu đã lên màn. Mờ chồng sớm hơn mốc đó thì có nguy cơ khách thấy một
    // nháy đen chen giữa ảnh bìa và video.
    //
    // Nếu video KHÔNG bao giờ chạy (trình duyệt chặn autoplay, hoặc người dùng bật
    // giảm chuyển động và không bấm play) thì class này không được gắn và ảnh bìa
    // ở nguyên đó — đúng ý đồ, không phải thiếu sót.
    video.addEventListener('playing', function () {
      video.classList.add('aefhv__vid--on');
    }, { once: true });

    var tieng = bindAudio(root, v2 ? [video, v2] : [video], function () { return dangChay; });

    /* ---------------------------------------------- DANH SÁCH NỐI TIẾP (2 video)
     * Boss hỏi 7/9/2026: video bánh trung thu hết thì tự nhảy sang video quảng cáo
     * giới thiệu cửa hàng. Vòng chạy: video 1 → video 2 → video 1 → … mãi mãi.
     *
     * 🔴 NGUYÊN TẮC GỐC: KHỐI NÀY CHỈ ĐƯỢC PHÉP CỘNG THÊM.
     *   Cả hai thẻ giữ `loop`, nên nếu mọi thứ dưới đây hỏng sạch — play() bị chối,
     *   video 2 tải không xong, JS ném lỗi — thì khách vẫn thấy một video chạy vòng,
     *   đúng bằng hiện trạng trước khi có tính năng. KHÔNG BAO GIỜ dựng lại kiểu
     *   "gỡ loop rồi nghe `ended`": kiểu đó biến một bảo đảm của trình duyệt thành
     *   một lời gọi có thể bị từ chối, và một cú chối là hero đứng hình vĩnh viễn.
     *
     * Vì `loop` còn đó nên `ended` không bao giờ bắn. Tín hiệu chuyển cảnh là
     * `timeupdate` khi sắp hết — và nó ĐẸP HƠN `ended` thật: video mới bắt đầu chạy
     * trong lúc video cũ còn nốt vài phần mười giây, nên hai đoạn phim MỜ CHỒNG lên
     * nhau thay vì cắt phựt.
     *
     * Ba mốc thời gian, và cả ba đều có lý do:
     *   NAP_TRUOC_GIAY   — nạp video kia khi video đang chạy còn ngần này giây. Đủ
     *                      sớm để kịp đệm (đo thật: WebKit 3,1s · Chromium 1,0s cho
     *                      bản SD đang phục vụ khách), đủ muộn để không đụng lúc
     *                      trang đang vẽ.
     *   CHUYEN_TRUOC_GIAY— bắt đầu mờ chồng trước khi hết ngần này giây.
     *   DUNG_SAU_MS      — dừng video cũ sau khi lớp mờ chồng đã kín hẳn.
     */
    var NAP_TRUOC_GIAY = 6;
    var CHUYEN_TRUOC_GIAY = 0.4;
    var DUNG_SAU_MS = 500;

    if (v2) {
      // `aefLoaded` được đặt NGAY ĐẦU attachSources, kể cả khi thẻ không có <source>
      // nào — nên một mình nó không đủ để nói "chạy được". readyState mới là câu
      // trả lời về KẾT QUẢ. [[reference_do_ket_qua_dung_do_loi_goi]]
      var sanSang = function (v) { return v.dataset.aefLoaded === '1' && v.readyState >= 3; };
      var dangDoi = false;

      var doiSang = function (toi) {
        var tu = dangChay;
        if (toi === tu || dangDoi) return;
        dangDoi = true;
        toi.currentTime = 0;
        var xong = function () {
          dangChay = toi;
          curVideo = toi;               // để nhánh visibilitychange chạy đúng thẻ
          root.classList.toggle('aefhv--v2', toi === v2);
          // Thẻ mới thừa kế trạng thái tiếng, thẻ cũ câm lại NGAY — không để hai
          // đoạn phim cùng kêu trong nửa giây mờ chồng.
          tieng.dongBo();
          window.setTimeout(function () {
            if (dangChay !== tu) tu.pause();
            dangDoi = false;
          }, DUNG_SAU_MS);
        };
        toi.addEventListener('playing', xong, { once: true });
        /* play() có thể RESOLVE mà `playing` vẫn không bao giờ bắn (khựng giữa
         * chừng khi đang đệm). Không có cửa này thì `dangDoi` kẹt ở true và hero
         * thôi chuyển cảnh vĩnh viễn — im lặng, vì chẳng có lỗi nào cả. */
        window.setTimeout(function () {
          if (!dangDoi || dangChay === toi) return;
          toi.removeEventListener('playing', xong);
          toi.pause();
          dangDoi = false;
        }, 8000);
        var p = toi.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            /* Chuyển cảnh hỏng thì KHÔNG làm gì cả — và đó mới là xử lý đúng.
             * `tu` vẫn mang `loop` nên nó tự chạy tiếp vòng nữa, khách không thấy
             * gì bất thường. Gỡ listener treo, nếu không lần sau nó bắn thêm một
             * phát vào đúng lúc trạng thái đã đổi. Mở chốt để vòng sau thử lại. */
            toi.removeEventListener('playing', xong);
            dangDoi = false;
          });
        }
      };

      var nhipChuyen = function (e) {
        var v = e.currentTarget;
        if (v !== dangChay) return;            // thẻ đang ẩn thì không có quyền quyết
        /* Ngoài tầm mắt hoặc tab nền thì KHÔNG nạp, KHÔNG chuyển cảnh. Hai lý do:
         *   · nạp video 2 cho người không nhìn hero là tiêu băng thông của khách
         *     cho thứ họ không thấy — và lời hứa in trong theme editor ("cuộn qua
         *     khỏi hero thì video 2 không tải byte nào") phải đúng cả với khách bật
         *     "giảm chuyển động", nhóm KHÔNG có bộ theo dõi tầm nhìn.
         *   · chuyển cảnh ngoài tầm mắt sẽ cho video mới chạy — kèm TIẾNG nếu khách
         *     đã bật — ở một chỗ không ai đang nhìn. */
        if (document.hidden || !inViewport(root)) return;
        /* Cổng LCP. Đặt TRƯỚC cả `attachSources(kia, true)` là có chủ đích: chưa chạm
     * thì không nạp trước, không đổi cảnh, không tốn một byte nào cho video 2. */
    if (!daTuongTac) return;

    var kia = (v === video) ? v2 : video;
        var d = v.duration;
        if (!d || !isFinite(d)) return;        // đang stream / chưa biết độ dài
        var conLai = d - v.currentTime;
        if (conLai > NAP_TRUOC_GIAY) return;

        if (!kia.dataset.aefLoaded) attachSources(kia, true);   // chỉ nạp, chưa chạy
        if (conLai <= CHUYEN_TRUOC_GIAY && sanSang(kia)) doiSang(kia);
      };

      video.addEventListener('timeupdate', nhipChuyen);
      v2.addEventListener('timeupdate', nhipChuyen);

      /* Nguồn hỏng (404, codec máy không giải mã được, mạng rớt giữa chừng). Hai việc:
       *
       * 1. Mở lại chốt `aefLoaded` để vòng sau còn thử nạp lại được. Không mở thì một
       *    cú hỏng nhất thời khoá video 2 vĩnh viễn — mà chốt ấy sinh ra để chống gọi
       *    trùng, chứ không phải để trừng phạt.
       * 2. NẾU video 2 đang là thứ khách nhìn thì phải VỀ NHÀ ngay. Đây là lỗ hổng
       *    duy nhất mà `loop` không vá được: `loop` giữ cho video đang chạy không
       *    dừng, nhưng video vừa HỎNG thì có `loop` cũng đứng. Lúc đó video 1 đang
       *    bị pause dưới đáy ⇒ hero đứng hình thật. Gỡ lớp phủ và cho video 1 chạy lại.
       */
      v2.addEventListener('error', function () {
        delete v2.dataset.aefLoaded;
        if (dangChay !== v2) return;
        dangDoi = false;
        dangChay = video; curVideo = video;
        root.classList.remove('aefhv--v2');
        tieng.dongBo();
        chay(video);
      });
    }

    // KHÔNG dùng IntersectionObserver để quyết định lúc bắt đầu — xem chú thích ở
    // afterLoad: IO đứng im trong tab nền. Mà "hero có nằm trong tầm nhìn không"
    // là thứ đọc được NGAY bằng getBoundingClientRect, không cần chờ ai gọi lại.
    // IO chỉ còn dùng cho trường hợp hero bị kéo xuống dưới màn hình đầu (Boss đổi
    // thứ tự section trong theme editor) — lúc đó chậm vài giây không sao.
    afterLoad(function () {
      if (inViewport(root)) { attachSources(video); return; }
      if (!('IntersectionObserver' in window)) { attachSources(video); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.disconnect();
          attachSources(video);
        });
      }, { rootMargin: '200px' });
      io.observe(root);
    });

    // Cuộn qua khỏi hero thì dừng cho đỡ tốn pin/CPU; cuộn về thì chạy lại.
    if (!REDUCED) {
      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!video.dataset.aefLoaded) return;
          // Chạy lại ĐÚNG video đang tới lượt, nhưng dừng CẢ HAI: chỉ dừng cái đang
          // chạy thì cái kia có thể còn kêu ngoài tầm mắt sau một cú chuyển cảnh.
          if (en.isIntersecting) chay(dangChay);
          else { video.pause(); if (v2) v2.pause(); }
        });
      }, { threshold: 0.15 });
      vis.observe(root);

      // Chrome DỪNG mọi video khi tab bị đưa ra nền, và không tự chạy lại khi
      // khách quay về — nó chỉ để đó đứng im. Không có đoạn này thì ai mở tab
      // khác rồi quay lại (chuyện xảy ra liên tục lúc so giá) sẽ thấy hero thành
      // một tấm ảnh chết. IntersectionObserver không cứu được vì khung hình
      // không hề đổi vị trí — chỉ có trạng thái hiển thị của tab đổi.
      //
      // Gắn ĐÚNG MỘT LẦN ở tầng document rồi đọc hero hiện tại qua biến module:
      // gắn lại theo mỗi lần init sẽ chồng thêm listener mỗi lần theme editor vẽ
      // lại section, và những listener cũ còn giữ chặt node đã bị vứt.
      if (!visBound) {
        visBound = true;
        document.addEventListener('visibilitychange', function () {
          var v = curVideo, r = curRoot;
          if (!v || !r || document.hidden || !v.dataset.aefLoaded) return;
          if (!inViewport(r)) return;
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        });
      }
    }
  }

  // Bọc trong hàm chứ không truyền thẳng `init` làm listener: listener nhận Event
  // làm tham số đầu, mà init giờ coi tham số đầu là phạm vi DOM để tìm hero.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor vẽ lại section mỗi lần Boss đổi một ô cài đặt (kéo thanh trượt
  // chiều cao chẳng hạn). Node cũ bị thay nên listener mất sạch — không có đoạn
  // này thì video đứng im ở ảnh bìa ngay giữa lúc Boss đang chỉnh, và Boss tưởng
  // mình vừa làm hỏng.
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target && e.target.querySelector) init(e.target);
  });
})();
